<template>  
  <card-seplag titulo="Controle de Solicitação de Ferias e Licença Premio">        
    <div class="p-col-12 defaultvalor" v-if="parametroFerias || parametroFerias">
        <h3><strong>Valor Atribuido para Todos os Orgãos: {{ parametroFerias.valorParametro }} </strong></h3>
    </div>    
    <div class="p-col-12 defaultvalor" v-else>
        <h3><strong>NÃO POSSUI PARAMETRO CADASTRADO - PERMISSAO_FERIAS</strong></h3>
    </div>    
    <div class="p-col-12" v-if="listaOrgao.length>0">
        <label><strong>Orgão para Liberação de solicitação de Ferias e Licença Premio: </strong></label>
    </div>
    <div class="p-col-12 divTabelaOrgao" v-if="listaOrgao.length>0"> 
        <DataTable :value="listaOrgao">
            <Column header="Férias" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                <template #body="slotProps">                           
                    <Checkbox 
                    :id="slotProps.data.codSeap" 
                    :inputId="slotProps.data.codSeap" 
                    name="orgaoSelecionados" 
                    :value="slotProps.data.codSeap" 
                    v-model="feriasSelecionados" 
                    :disabled="desabilitarAlteracao"/>
                </template>
            </Column>
            <Column header="Licenças" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                <template #body="slotProps">                           
                    <Checkbox 
                    :id="slotProps.data.codSeap" 
                    :inputId="slotProps.data.codSeap" 
                    name="orgaoSelecionados" 
                    :value="slotProps.data.codSeap" 
                    v-model="LPSelecionados" 
                    :disabled="desabilitarAlteracao"/>
                </template>
            </Column>
            <Column field="labelDropDaw" header="Orgão" />
        </DataTable>
    </div>    
    <div class="p-col-12 p-md-4">
        <Button label="Salvar" class="p-button-success" icon="pi pi-save" @click="salvarLiberacao()" />
    </div>
  </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: 'liberacaoFerias',
     components: { CardSeplag },   
    data: function(){
        return{
            desabilitarAlteracao: true,
            listaOrgao: [],
            parametroFerias: null,
            parametroLP: null,
            feriasSelecionados: [],
            LPSelecionados: []
        }
    }, 
    methods:{
        carregarDados(){  
            this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then(res=>{
                let orgao =  res.data.filter(element =>{
                    return element.codSeap != null;
                });
                orgao.sort((a, b) => a.codSeap - b.codSeap);
                this.listaOrgao = orgao.map(function (element) {
                return {
                    ...element,
                    labelDropDaw: element.codSeap + " - " + element.descOrgao,
                };
                });
                this.$http.post(`${baseApiUrl}/parametro/busca`,JSON.stringify({
                    busca:'PERMISSAO_FERIAS',
                    idenSistema: process.env.VUE_APP_CODIGO_SISTEMA
                })).then(res2=>{
                    if(res2.data.totalElements>0){
                        this.parametroFerias = res2.data.content[0]
                        this.desabilitarAlteracao = false
                        this.$http.get(`${baseApiUrl}/parametro/orgao/all/${res2.data.content[0].idenParametro}`).then(res3=>{
                            if(res3.data && res3.data.length > 0){
                                for(var i=0; i<res3.data.length; i++){
                                    if(res3.data[i].valorParametro == 'HABILITADO'){
                                        this.feriasSelecionados.push(res3.data[i].orgao.codSeap)
                                    }
                                }
                            }
                        })

                    }
                })
                this.$http.post(`${baseApiUrl}/parametro/busca`,JSON.stringify({
                    busca:'PERMISSAO_LICENCA_PREMIO',
                    idenSistema: process.env.VUE_APP_CODIGO_SISTEMA
                })).then(res4=>{
                    if(res4.data.totalElements>0){  
                        this.parametroLP = res4.data.content[0]
                        this.desabilitarAlteracao = false
                        this.$http.get(`${baseApiUrl}/parametro/orgao/all/${res4.data.content[0].idenParametro}`).then(res3=>{
                            if(res3.data && res3.data.length > 0){
                                for(var i=0; i<res3.data.length; i++){
                                    if(res3.data[i].valorParametro == 'HABILITADO'){
                                        this.LPSelecionados.push(res3.data[i].orgao.codSeap)
                                    }
                                }
                            }
                        })
                    }
                })
            })  
        },
        salvarLiberacao(){
            let bodyRequest = []
            for(let i=0; i< this.feriasSelecionados.length;i++){
                bodyRequest.push({
                    id:this.feriasSelecionados[i],
                    valor: 'HABILITADO'
                })
            }
            this.$http.post(`${baseApiUrl}/parametro/salvar/${this.parametroFerias.idenParametro}`,JSON.stringify(bodyRequest)).then(() => {                
                this.$toast.add({severity:'success', summary: 'Ação Efetuada', detail:"Férias Habilitados nos Órgãos Com Sucesso!", life: 5000});  
            })
            bodyRequest = []
            for(let i=0; i< this.LPSelecionados.length;i++){
                bodyRequest.push({
                    id:this.LPSelecionados[i],
                    valor: 'HABILITADO'
                })
            }
            this.$http.post(`${baseApiUrl}/parametro/salvar/${this.parametroLP.idenParametro}`,JSON.stringify(bodyRequest)).then(() => {                
                this.$toast.add({severity:'success', summary: 'Ação Efetuada', detail:"Licença Prêmio Habilitados nos Órgãos Com Sucesso!", life: 5000});  
            })
        }
    },
    mounted(){
        this.carregarDados()
    }

}
</script>

<style scoped>
.defaultvalor{
    border-bottom: 1px solid #d5d5d5;
    padding: 1.1em;
    text-align: center;
}
.divTabelaOrgao{
    max-height: 30vw;
    overflow-y: scroll;
    margin-bottom: 10px;
}
</style>